import http from './httpRequest.js'

class MomentApi {
}

MomentApi.prototype.publish = function (content, images) {
	return http({
		url: '/moments/publish',
		method: 'post',
		data: {
			content: content,
			images: images
		}
	})
}

MomentApi.prototype.timeline = function (page, size) {
	return http({
		url: '/moments/timeline',
		method: 'get',
		params: {
			page: page,
			size: size
		}
	})
}

MomentApi.prototype.remove = function (id) {
	return http({
		url: '/moments/delete/' + id,
		method: 'delete'
	})
}

export default MomentApi
